import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import lodashIsEqual from 'lodash/fp/isEqual';

import branch from 'client/core/branch';
import { SCREEN_ID_SEARCH_FILTERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import NavbarButton from 'client/components/NavbarButton';
import Navbar from 'client/components/Navbar';
import SrSearchFilterList from 'client/components/SrSearchFilterList';

import AgentActions from 'client/actions/Agent';
import MarketActions from 'client/actions/Market';

@withTransitionHook
@branch({
  viewingRenter: ['agentMapView', 'viewingRenter'],
  viewingRenterSearchFilters: ['agentMapView', 'viewingRenterSearchFilters'],
  marketsById: ['markets', 'byId'],
})
@withRouter
@withScreenId(SCREEN_ID_SEARCH_FILTERS)
@withScrollToTop
class AgentSearchPage extends Component {
  static fetchData(match, inject) {
    const agentUserId = match.params.agentUserId
      ? parseInt(match.params.agentUserId, 10)
      : inject.state.get(['currentUser', 'id']);

    return Promise.all([
      AgentActions.getAgentTours(inject, { agentUserId }),
      MarketActions.getList(inject),
    ]).then(() => {
      return AgentActions.setViewingTour(inject, parseInt(match.params.tourId, 10));
    });
  }

  static getPageMetadata = () => ({
    pageTitle: 'Filter Search | Sunroom Rentals',
    section: 'Listings',
    // canonical: '/',
    keywords: 'rent, home, austin, tour, apartment',
    description:
      'Spend less time scheduling tours, our rental experts ' +
      'will schedule and confirm tours for you.',
  });

  static propTypes = {
    viewingRenter: PropTypes.object.isRequired,
    viewingRenterSearchFilters: PropTypes.object.isRequired,
    marketsById: PropTypes.object,
  };

  _onApplyFiltersClick = () => {
    const { viewingRenter } = this.props;
    this.props.dispatch(AgentActions.saveViewingRenterSearchFilters, {
      userId: viewingRenter.id,
    });
    this._onBack();
  };

  _onChangeFilter = (filterKey, filterValue) => {
    this.props.dispatch(AgentActions.updateViewingRenterSearchFilters, {
      filterKey,
      filterValue,
    });
  };

  _onCancelFilters = () => {
    this._onBack();
  };

  _onBack = () => {
    const { history } = this.props;
    history.push('/agent/map');
  };

  render() {
    const { viewingRenterSearchFilters, viewingRenter, match, marketsById } = this.props;

    if (!viewingRenter) {
      return <div />;
    }

    const isDisable = lodashIsEqual(viewingRenter.searchFilters, viewingRenterSearchFilters);

    return (
      <div className="page-explore">
        <div className={classNames('modal filters expanded')}>
          <Navbar
            redirectLogoTo="/agent/tours"
            leftButton={<NavbarButton onClick={this._onCancelFilters}>Cancel</NavbarButton>}
          />

          <div className="contentContainer">
            <SrSearchFilterList
              listingsViewMode="map"
              isDisable={isDisable}
              redirectTo={`/agent/${match.params.tourId}/search`}
              filters={viewingRenterSearchFilters}
              onSubmit={this._onApplyFiltersClick}
              onChange={this._onChangeFilter}
              market={marketsById[viewingRenter.searchFilters.marketId]}
            />
          </div>
        </div>
      </div>
    );
  }
}

AgentSearchPage.displayName = 'AgentSearchPage';

export default AgentSearchPage;
